import './index.scss'

$(document).scroll(function () {
    var scroH = $(document).scrollTop();
    var viewH = $(window).height();
    var img1Top = $('.section1 .img').offset().top;
    var img1H = $('.section1 .img').height();
    var img2Top = $('.section3 .img').offset().top;
    var img2H = $('.section3 .img').height();
    var img3Top = $('.section4 .img').offset().top;
    var img3H = $('.section4 .img').height();

    if(window.screen.width > 1024){
        if (scroH > 0 && scroH <= img1Top + img1H) {
            $('.section1 .img b').css('transform', 'translateY(-' + scroH / 10 + 'px)')
        } else if (scroH > img2Top - viewH && scroH <= img2Top + img2H) {
            $('.section3 .img b').css('transform', 'translateY(-' + (scroH - img2Top + viewH) / 12 + 'px)')
        } else if (scroH > img3Top - viewH && scroH <= img3Top + img3H) {
            $('.section4 .img b').css('transform', 'translateY(-' + (scroH - img3Top + viewH) / 10 + 'px)')
        }
    }
});